import { Table as StagesTable } from '@/components/event_stage/table'

interface Props {
  eventId: string
}

export const EditStages = ({ eventId }: Props) => {
  return (
    <>
      <StagesTable eventId={eventId} pageSize={10} title="Stages" createable fixedHeight updateable />
    </>
  )
}
